import styled, { css } from "styled-components";

interface SkinProps {
  $isGriffle?: boolean;
}

export const CalendarWrapper = styled.div<SkinProps>`
  background: #fff;
  border-radius: ${({ $isGriffle }) => ($isGriffle ? "12px" : "8px")};
  padding: 20px;
  font-family: ${({ $isGriffle }) =>
    $isGriffle ? "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif" : "inherit"};
`;

export const CalendarHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
`;

export const MonthTitle = styled.h3<SkinProps>`
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: ${({ $isGriffle }) => ($isGriffle ? "#1e1b4b" : "#212529")};
`;

export const NavButton = styled.button<SkinProps>`
  background: none;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #495057;
  transition: all 0.15s;

  &:hover {
    background-color: ${({ $isGriffle }) => ($isGriffle ? "rgba(99, 102, 241, 0.1)" : "#f8f9fa")};
    border-color: ${({ $isGriffle }) => ($isGriffle ? "#6366f1" : "#adb5bd")};
  }
`;

export const NavButtons = styled.div`
  display: flex;
  gap: 4px;
`;

export const WeekdayHeader = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 1px;
  margin-bottom: 4px;
`;

export const WeekdayCell = styled.div`
  text-align: center;
  font-size: 12px;
  font-weight: 600;
  color: #6c757d;
  padding: 8px 0;
  text-transform: uppercase;
`;

export const CalendarGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 1px;
`;

export const DayCell = styled.div<SkinProps & { $isToday: boolean; $isCurrentMonth: boolean }>`
  min-height: 80px;
  padding: 4px;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  transition: background-color 0.15s;

  ${({ $isToday, $isGriffle }) =>
    $isToday &&
    css`
      background-color: ${$isGriffle ? "rgba(99, 102, 241, 0.05)" : "rgba(13, 110, 253, 0.05)"};
      border-color: ${$isGriffle ? "#6366f1" : "#0d6efd"};
    `}

  ${({ $isCurrentMonth }) =>
    !$isCurrentMonth &&
    css`
      opacity: 0.4;
    `}
`;

export const DayNumber = styled.span<SkinProps & { $isToday: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  font-size: 12px;
  font-weight: 500;
  margin-bottom: 2px;
  border-radius: 50%;
  color: ${({ $isToday, $isGriffle }) => ($isToday ? ($isGriffle ? "#6366f1" : "#0d6efd") : "#495057")};
  font-weight: ${({ $isToday }) => ($isToday ? 700 : 500)};
`;

export const AssignmentIndicator = styled.button<SkinProps & { $state: string }>`
  display: block;
  width: 100%;
  background: none;
  border: none;
  padding: 2px 4px;
  margin-bottom: 1px;
  border-radius: 3px;
  font-size: 10px;
  line-height: 1.3;
  text-align: left;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: opacity 0.15s;

  ${({ $state }) => {
    switch ($state) {
      case "active":
        return css`
          background-color: #d1e7dd;
          color: #0f5132;
        `;
      case "pending":
        return css`
          background-color: #fff3cd;
          color: #856404;
        `;
      case "completed":
        return css`
          background-color: #cfe2ff;
          color: #084298;
        `;
      case "draft":
        return css`
          background-color: #e9ecef;
          color: #495057;
        `;
      default:
        return css`
          background-color: #e9ecef;
          color: #495057;
        `;
    }
  }}

  &:hover {
    opacity: 0.8;
  }
`;

export const ViewToggleWrapper = styled.div<SkinProps>`
  display: flex;
  gap: 4px;
  background: #f0f0f0;
  border-radius: 8px;
  padding: 3px;
`;

export const ViewToggleButton = styled.button<SkinProps & { $isActive: boolean }>`
  padding: 6px 14px;
  border: none;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;

  ${({ $isActive, $isGriffle }) =>
    $isActive
      ? css`
          background-color: ${$isGriffle ? "#6366f1" : "#0d6efd"};
          color: #fff;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
        `
      : css`
          background-color: transparent;
          color: #495057;

          &:hover {
            background-color: rgba(0, 0, 0, 0.05);
          }
        `}
`;
